import React, { Component } from "react";
import {
  Box,
  CircularProgress
} from '@material-ui/core';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  ButtonGroup
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

import { Formik, Form, Field } from "formik";
import Select from 'react-select';
import * as Yup from "yup";
import queryString from 'query-string';
import Loading from "react-fullscreen-loading";
import ProgressButton from "../../components/Button/ProgressButton";

import StickyPageHeader from '../../components/PageHeader/StickyPageHeader';
import BreadCrumb from "../../components/Navs/Breadcrumb";

import UploadDocumentDialog from "./Partial/UploadDocumentDialog";
import VehicleChecklist from './Partial/VehicleChecklist';

import apiUtil from "../../api/apiUtil";
import api from "../../api/api.js";


import { ReactComponent as DeleteIcon } from '../../assets/img/icons/delete.svg';

const VehicleSchema = Yup.object({
  plate_no: Yup.string().required('Value is required'),
  manufacturer: Yup.string().required('Value is required'),
  model: Yup.string().required('Value is required'),
  colour: Yup.string().required('Value is required'),
  load_capacity: Yup.number().nullable(true)
    .typeError('Value must be a number'),
  engine_capacity: Yup.number().nullable(true)
    .typeError('Value must be a number'),
  inspection_interval_in_months: Yup.number().nullable(true)
    .typeError('Value must be a number'),
  service_interval_in_months: Yup.number().nullable(true)
    .typeError('Value must be a number'),
  inspection_remind_in_weeks: Yup.number().nullable(true)
    .typeError('Value must be a number'),
  service_remind_in_weeks: Yup.number().nullable(true)
    .typeError('Value must be a number'),
});

class VehicleForm extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      dataId: '',
      errors: {},
      isLoading: false,
      pageLoading: false,
      readOnly: false,
      canSave: true,
      oldData: null,
      typeList: [],
      selectedType: {
        id: '0',
        name: '',
      },
      equipmentTypeList: [],
      selectedEquipmentType: {
        id: '0',
        name: '',
      },
      formData: {
        plate_no: '',
        manufacturer: '',
        model: '',
        colour: '',
        load_capacity: '',
        engine_capacity: '',
        registration_date: null,
        road_tax_expiry_date: null,
        inspection_date: null,
        vehicle_type_id: null,
        equipment_type_id: null,
        service_date: null,
        service_interval_in_months: '',
        inspection_interval_in_months: '',
        service_remind_in_weeks: '',
        inspection_remind_in_weeks: '',
        service_document_urls: []
      }
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.populateData = this.populateData.bind(this);
  }

  componentWillMount() {
    this._isMounted = true;

    let urlQuery = queryString.parse(window.location.search);
    if (urlQuery.id !== undefined) {
      this.setState({
        pageLoading: true,
        dataId: urlQuery.id
      });
      this.getType();
      this.getData(urlQuery.id);
      document.title = "View Equipment | WMS";
    } else {
      document.title = "Create View | WMS";
      this.getType();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getData = id => {
    api.details("vehicles", id).then((result) => {
      apiUtil.parseResult(
        result,
        (data) => {
          let result = data && data.result ? data.result : null;

          if (result) {
            this.populateData(result);
          } else {
            apiUtil.toast(data.errorMessage, 'warning');
          }
        },
        (error, type) => {
          apiUtil.toast(error.message, 'error');
        }
      );
    });
  }

  getType = async () => {
    let params = {
      app_id: 1
    };

    api.read("vehicle_types", params, null, 'admin').then((data) => {
      // console.log(data);
      // console.log(data.data.data.result);
      if (Array.isArray(data.data.data.result)) {
        let typeList = [];
        data.data.data.result.forEach((val) => {
          typeList.push({
            value: val.id,
            label: val.name,
            name: val.name
          });
        });

        this.setState({
          typeList: typeList,
          pageLoading: false
        });
      } else {
        apiUtil.toast('Failed to get equipment types.', 'error');
      }
    }).catch(error => console.log(error));

    api.read("equipment_types", params, null, 'admin').then((data) => {
      // console.log(data);
      // console.log(data.data.data.result);
      if (Array.isArray(data.data.data.result)) {
        let equipmentTypeList = [];
        data.data.data.result.forEach((val) => {
          equipmentTypeList.push({
            value: val.id,
            label: val.name,
            name: val.name
          });
        });

        this.setState({
          equipmentTypeList: equipmentTypeList,
          pageLoading: false
        });
      } else {
        apiUtil.toast('Failed to get equipment types.', 'error');
      }
    }).catch(error => console.log(error));
  }

  populateData = data => {
    let formData = this.state.formData;

    for (const key in formData) {
      if (key.includes('date') && data[key]) {
        formData[key] = new Date(data[key]);
      } else {
        formData[key] = data[key];
      }
    }

    if (formData.service_document_urls === null) {
      formData.service_document_urls = [];
    }

    this.setState({
      //oldData: data,
      pageLoading: false,
      formData: formData,
    });

    if (data.vehicle_type_id) {
      this.handleTypeChange({ value: data.vehicle_type_id, name: data.vehicle_type.name });
    }

    if (data.equipment_type_id && data.equipment_type) {
      this.handleEquipmentTypeChange({ value: data.equipment_type_id, name: data.equipment_type.name });
    }
  }

  handleInputChange = event => {
    let formState = this.state.formData;
    formState[event.target.name] = event.target.value;

    this.setState({
      formData: formState
    });
  }

  handleSelectChange = (event, name) => {
    let formState = this.state.formData;
    formState[name] = event.value;

    this.setState({
      formData: formState
    });
  }

  changeDate = (date, name) => {
    let formData = this.state.formData;
    formData[name] = date;

    this.setState({
      formData: formData
    });
  }

  handleTypeChange = async (event) => {
    this.setState({
      selectedType: {
        id: event.value,
        name: event.name,
      }
    });
  }

  handleEquipmentTypeChange = async (event) => {
    this.setState({
      selectedEquipmentType: {
        id: event.value,
        name: event.name,
      }
    });
  }

  handleSubmit = values => {
    let formData = this.state.formData;
    for (const prop in formData) {
      if (values[prop] === undefined) {
        values[prop] = formData[prop];
      }
    }

    // Hardcode app id
    values.app_id = 1;
    values.vehicle_type_id = this.state.selectedType.id;
    values.equipment_type_id = this.state.selectedEquipmentType.id;

    values.registration_date = this.state.formData.registration_date ? moment(this.state.formData.registration_date).format('YYYY-MM-DD') : null;
    values.road_tax_expiry_date = this.state.formData.road_tax_expiry_date ? moment(this.state.formData.road_tax_expiry_date).format('YYYY-MM-DD') : null;
    values.inspection_date = this.state.formData.inspection_date ? moment(this.state.formData.inspection_date).format('YYYY-MM-DD') : null;
    values.service_date = this.state.formData.service_date ? moment(this.state.formData.service_date).format('YYYY-MM-DD') : null;
    // console.log("values", values);

    if (this.state.dataId === "") { // create
      this.setState({
        isLoading: true
      });

      api.create("vehicles", values)
        .then(data => {
          this.setState({
            isLoading: false,
          });

          console.log(data)

          if (data.data.status === 200) {
            this.props.history.push('../vehicles/all-vehicles');
          } else {
            apiUtil.toast(data.errorMessage, 'error');
          }
        })
        .catch(error => apiUtil.toast(error.message, 'error'));
    } else { // update
      //delete values.end_user_name;
      values.id = this.state.dataId;
      this.setState({
        isLoading: true
      });

      api.update("vehicles/" + this.state.dataId, values).then(data => {
        this.setState({
          isLoading: false,
        });

        if (data.data.status === 200) {
          this.props.history.push('../vehicles/all-vehicles');
        } else {
          apiUtil.toast(data.errorMessage, 'error');
        }
      });
    }
  }

  vehicleChecklistDialog = () => {
    if (this.state.dataId && this.state.dataId > 0) {
      return <Row className="pb-5 mb-5">
        <Col md={{ size: 12 }}>
          <Container>
            <VehicleChecklist vehicleId={this.state.dataId} />
          </Container>
        </Col>
      </Row>
    } else {
      return '';
    }
  }

  toggleUploadDialog = show => {
    this.setState({
      uploadModal: true
    });
  }

  uploadDialog = () => {
    return <UploadDocumentDialog
      modal={this.state.uploadModal}
      onImport={async (data, fileName) => {
        this.setState({
          uploadModal: false
        });

        if (data) {
          this.setState({
            isLoading: true
          });

          let formData = new FormData();
          formData.append('doc', data);
          formData.append('doc_name', fileName);
          formData.append('folder_name', 'equipment_documents');
          console.log(formData);
          api.uploadImage('upload', formData).then((data) => {
            if (data.data.data.result) {
              console.log(data.data.data.result);
              let documentUrl = data.data.data.result.file_url;

              let formData = this.state.formData;
              formData.service_document_urls.push({
                document_url: documentUrl,
                file_name: fileName,
                is_deleted: false
              });

              this.setState({
                formData: formData,
                isLoading: false
              });
            } else {
              apiUtil.toast('Failed to upload document.', 'error');
            }
          }).catch(error => console.log(error));

          this.setState({
            isLoading: false,
          });
        }
      }}
      onClose={() => {
        this.setState({
          uploadModal: false
        });
      }}
    />
  }

  showDocuments = () => {
    const theClass = this;
    let documents = this.state.formData.service_document_urls;

    return documents.map(function (v, k) {
      return (<div className='col-12'>
        <a href={v.document_url} target="_blank" rel="noopener noreferrer" >
          <span>{v.file_name}</span>
        </a>
        <button title="Delete" type="button" className="btn-icon btn-delete" onClick={e => theClass.deleteDocument(k)}>
          <DeleteIcon />
        </button>
      </div>)
    })
  }

  deleteDocument = (idx) => {
    let formData = this.state.formData;

    if (formData.service_document_urls) {
      delete formData.service_document_urls[idx];
      formData.service_document_urls.splice(idx, 1);
    }

    this.setState({
      formData: formData,
      isLoading: false
    });
  }

  render() {
    return (
      <Box className="dashboard-page">
        <StickyPageHeader>
          <BreadCrumb />
          <h1 className="page-title">{this.state.dataId !== "" ? "Update Equipment" : "Create Equipment"}</h1>
        </StickyPageHeader>

        <Loading loading={this.state.pageLoading} background="#f5f5f5" loaderColor="#e89cae" />
        <Row>
          <Formik
            enableReinitialize={true}
            initialValues={{
              plate_no: this.state.formData.plate_no,
              manufacturer: this.state.formData.manufacturer,
              model: this.state.formData.model,
              colour: this.state.formData.colour,
              load_capacity: this.state.formData.load_capacity,
              engine_capacity: this.state.formData.engine_capacity,
              registration_date: this.state.formData.registration_date,
              road_tax_expiry_date: this.state.formData.road_tax_expiry_date,
              inspection_date: this.state.formData.inspection_date,
              vehicle_type_id: this.state.formData.vehicle_type_id,
              equipment_type_id: this.state.formData.equipment_type_id,
              service_date: this.state.formData.service_date,
              service_interval_in_months: this.state.formData.service_interval_in_months,
              inspection_interval_in_months: this.state.formData.inspection_interval_in_months,
              service_remind_in_weeks: this.state.formData.service_remind_in_weeks,
              inspection_remind_in_weeks: this.state.formData.inspection_remind_in_weeks
            }}
            validationSchema={VehicleSchema}
            onSubmit={values => { this.handleSubmit(values); }}>
            {({
              handleSubmit,
              setFieldValue,
              setFieldTouched,
              values,
              errors,
              touched,
              validateForm
            }) => (
              <Form>
                <Col md={{ size: 12 }}>
                  <Container className={this.state.readOnly ? "overlay" : ""}>
                    <Card className="mt-3">
                      <CardBody className="pt-0">
                        <Row>
                          <Col xs="12">
                            <h4 className="font-weight-bold mb-4">Equipment's information</h4>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Plate Number*
                            </Label>
                            <Field className="form-control form-input" name="plate_no" value={this.state.formData.plate_no || ''} onChange={this.handleInputChange} />
                            {
                              errors.plate_no && touched.plate_no ? (
                                <div className="invalid-feedback d-block">
                                  {errors.plate_no}
                                </div>
                              ) : null
                            }
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Manufacturer*
                            </Label>
                            <Field className="form-control form-input" name="manufacturer" value={this.state.formData.manufacturer || ''} onChange={this.handleInputChange} />
                            {
                              errors.manufacturer && touched.manufacturer ? (
                                <div className="invalid-feedback d-block">
                                  {errors.manufacturer}
                                </div>
                              ) : null
                            }
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Model*
                            </Label>
                            <Field className="form-control form-input" name="model" value={this.state.formData.model || ''} onChange={this.handleInputChange} />
                            {
                              errors.model && touched.model ? (
                                <div className="invalid-feedback d-block">
                                  {errors.model}
                                </div>
                              ) : null
                            }
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Equipment Color*
                            </Label>
                            <Field className="form-control form-input" name="colour" value={this.state.formData.colour || ''} onChange={this.handleInputChange} />
                            {
                              errors.colour && touched.colour ? (
                                <div className="invalid-feedback d-block">
                                  {errors.colour}
                                </div>
                              ) : null
                            }
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Equipment Checklist Type*
                            </Label>
                            <Select value={{ label: this.state.selectedType.name, value: this.state.selectedType.id }} className="form-input no-border" options={this.state.typeList} onChange={(e) => this.handleTypeChange(e)} />
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Equipment Type*
                            </Label>
                            <Select value={{ label: this.state.selectedEquipmentType.name, value: this.state.selectedEquipmentType.id }} className="form-input no-border" options={this.state.equipmentTypeList} onChange={(e) => this.handleEquipmentTypeChange(e)} />
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Load Capacity
                            </Label>

                            <Field className="form-control form-input" type="text" name="load_capacity" value={this.state.formData.load_capacity || ''} onChange={this.handleInputChange} />
                            {
                              errors.load_capacity && touched.load_capacity ? (
                                <div className="invalid-feedback d-block">
                                  {errors.load_capacity}
                                </div>
                              ) : null
                            }
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Engine Capacity
                            </Label>
                            <Field className="form-control form-input" type="text" name="engine_capacity" value={this.state.formData.engine_capacity || ''} onChange={this.handleInputChange} />
                            {
                              errors.engine_capacity && touched.engine_capacity ? (
                                <div className="invalid-feedback d-block">
                                  {errors.engine_capacity}
                                </div>
                              ) : null
                            }
                          </Col>
                        </Row>

                        <Row className="d-none">
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Registration Date
                              </Label>
                              <div className="form-input">
                                <DatePicker dateFormat="dd/MM/yyyy" className="form-control" selected={this.state.formData.registration_date} onChange={date => this.changeDate(date, 'registration_date')} isClearable />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                RoadTax Expiry Date
                              </Label>
                              <div className="form-input">
                                <DatePicker dateFormat="dd/MM/yyyy" className="form-control" selected={this.state.formData.road_tax_expiry_date} onChange={date => this.changeDate(date, 'road_tax_expiry_date')} readOnly="readonly" />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Inspection Date
                              </Label>
                              <div className="form-input">
                                <DatePicker dateFormat="dd/MM/yyyy" className="form-control" selected={this.state.formData.inspection_date} onChange={date => this.changeDate(date, 'inspection_date')} isClearable />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Inspection Date Interval (months)
                              </Label>
                              <Field className="form-control form-input" type="text" name="inspection_interval_in_months" value={this.state.formData.inspection_interval_in_months || ''} onChange={this.handleInputChange} />
                              {
                                errors.inspection_interval_in_months && touched.inspection_interval_in_months ? (
                                  <div className="invalid-feedback d-block">
                                    {errors.inspection_interval_in_months}
                                  </div>
                                ) : null
                              }
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Inspection Reminder (weeks before)
                              </Label>
                              <Field className="form-control form-input" type="text" name="inspection_remind_in_weeks" value={this.state.formData.inspection_remind_in_weeks || ''} onChange={this.handleInputChange} />
                              {
                                errors.inspection_remind_in_weeks && touched.inspection_remind_in_weeks ? (
                                  <div className="invalid-feedback d-block">
                                    {errors.inspection_remind_in_weeks}
                                  </div>
                                ) : null
                              }
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Service Date
                              </Label>
                              <div className="form-input">
                                <DatePicker dateFormat="dd/MM/yyyy" className="form-control" selected={this.state.formData.service_date} onChange={date => this.changeDate(date, 'service_date')} isClearable />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Service Date Interval (months)
                              </Label>
                              <Field className="form-control form-input" type="text" name="service_interval_in_months" value={this.state.formData.service_interval_in_months || ''} onChange={this.handleInputChange} />
                              {
                                errors.service_interval_in_months && touched.service_interval_in_months ? (
                                  <div className="invalid-feedback d-block">
                                    {errors.service_interval_in_months}
                                  </div>
                                ) : null
                              }
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <div className="mb-4">
                              <Label className="control-label">
                                Service Reminder (weeks before)
                              </Label>
                              <Field className="form-control form-input" type="text" name="service_remind_in_weeks" value={this.state.formData.service_remind_in_weeks || ''} onChange={this.handleInputChange} />
                              {
                                errors.service_remind_in_weeks && touched.service_remind_in_weeks ? (
                                  <div className="invalid-feedback d-block">
                                    {errors.service_remind_in_weeks}
                                  </div>
                                ) : null
                              }
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                              Service Documents
                            </Label>
                            <Button
                              className="btn-multiple-state mr-3"
                              color="info"
                              outline={true}
                              type="button"
                              disabled={this.state.isLoading}
                              onClick={() => this.toggleUploadDialog(true)}>
                              Upload Document
                              {this.state.isLoading &&
                                <CircularProgress size={20} />}
                            </Button>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="12" className="mt-3">
                            <Label className="control-label">
                            </Label>
                            <Row>
                              {this.showDocuments()}
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    <div className="d-flex justify-content-between">
                      <Card>
                      </Card>
                      <ButtonGroup>
                        {(!this.state.readOnly || this.state.canSave) && <Card>
                          <ProgressButton
                            type={'submit'}
                            color={'secondary'}
                            isLoading={this.state.isLoading}
                          >
                            <Box pl={2} pr={2}>Submit</Box>
                          </ProgressButton>
                        </Card>}
                      </ButtonGroup>
                    </div>
                  </Container>
                </Col>
              </Form>
            )}
          </Formik>
        </Row>
        {this.vehicleChecklistDialog()}
        {this.uploadDialog()}
      </Box>
    );
  }
}

export default VehicleForm;